import { render, staticRenderFns } from "./MyQnA.vue?vue&type=template&id=c4406fda"
import script from "./MyQnA.vue?vue&type=script&lang=js"
export * from "./MyQnA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports